import React, { useState, useLayoutEffect, useRef } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Grid from '@nubank/nuds-web/components/Grid/Grid';

import Protection from '../Protection/Protection';
import RatesMGMLite from '../../../../components/Rates/RatesMGMLite';
import KnowMore from '../KnowMore/KnowMore';

const Blocks = () => {
  const getProtectionHeight = useRef(null);
  const getRatesHeight = useRef(null);
  const getKnowMoreHeight = useRef(null);
  const [blocksHeight, setBlocksHeight] = useState(0);

  // 130
  // Set same height for all blocks
  useLayoutEffect(() => {
    const blocksHeightArr = [];
    blocksHeightArr.push((getProtectionHeight.current.offsetHeight - 115));
    blocksHeightArr.push(getRatesHeight.current.offsetHeight - 115);
    blocksHeightArr.push(getKnowMoreHeight.current.offsetHeight);

    const sortedBlocksHeight = blocksHeightArr.sort().reverse();
    setBlocksHeight(sortedBlocksHeight[0]);
  }, []);

  return (
    <Box
      tag="section"
      paddingHorizontal={{ xs: '0', lg: '56px', xl: '20x' }}
      marginBottom={{ xs: '-20px', lg: '12x' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0x' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        {/* CONTENT BOX */}

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 10' }}
          gridRow="1"
        >
          <Box
            display="flex"
            flexDirection={{ xs: 'column', lg: 'row' }}
            alignItems={{ xs: 'center', lg: 'flex-end' }}
            justifyContent={{ xs: 'center', lg: 'space-between' }}
          >

            {/* Protection */}
            <Box
              ref={getProtectionHeight}
              width={{ xs: '100%', lg: '31%' }}
              minHeight={{ xs: 'auto', lg: `${blocksHeight}px` }}
            >
              <Protection />
            </Box>

            {/* Rates */}
            <Box
              ref={getRatesHeight}
              width={{ xs: '100%', lg: '31%' }}
              minHeight={{ xs: 'auto', lg: `${blocksHeight}px` }}
            >
              <RatesMGMLite />
            </Box>

            {/* Know More */}
            <Box
              ref={getKnowMoreHeight}
              width={{ xs: '100%', lg: '31%' }}
              minHeight={{ xs: 'auto', lg: `${blocksHeight}px` }}
            >
              <KnowMore />
            </Box>

          </Box>

        </Grid.Child>
      </Grid>
    </Box>
  );
};

export default Blocks;
